import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import {
    VStack,
    HStack,
    Text,
    Radio,
    RadioGroup,
    Box,
    Button,
} from '@chakra-ui/react';
import { useAppStore } from '../../state/store';
import { ManageDialogFrame, ManageDialogCloseFooter, ManageDialogPrimaryButton } from './ManageDialogFrame';
import { useBIMStore } from '../../state/useBIMStore';
import { useManageSettingsStore } from '../../state/useManageSettingsStore';

export function StartingViewDialog() {
    const { t } = useTranslation();
    const isOpen = useAppStore((state) => state.manageDialog === 'startingView');
    const onClose = useAppStore((state) => state.closeManageDialog);
    const project = useBIMStore((state) => state.project);
    const startingViewId = useManageSettingsStore((state) => state.startingViewId);
    const setStartingView = useManageSettingsStore((state) =>state.setStartingView); const [draft, setDraft] = useState<string | null>(null);

    useEffect(() => {
        if (isOpen) {
            setDraft(startingViewId);
        }
    }, [isOpen, startingViewId]);

    const handleSave = () => {
        setStartingView(draft);
        onClose();
    };

    const views = Array.from(project.views.values());

    return (
        <ManageDialogFrame
            title={t('manage.startingView')}
            isOpen={isOpen}
            onClose={onClose}
            footer={
                <ManageDialogCloseFooter
                    onClose={onClose}
                    extra={
                        <ManageDialogPrimaryButton
                            label={t('manage.oK')}
                            onClick={handleSave}
                        />
                    }
                />
            }
        >
            <VStack spacing={3} align="stretch">
                <Text fontSize="xs" color="var(--color-text-secondary)">{t('manage.chooseWhichViewOpensWhenTheProjectLoads')}</Text>
                <RadioGroup value={draft ?? ''} onChange={(value) => setDraft(value)}>
                    <VStack align="stretch" spacing={1} maxH="45vh" overflowY="auto">
                        {views.map((view) => (
                            <Box
                                key={view.id}
                                p={2}
                                borderRadius="var(--cad-radius-sm)"
                                borderWidth="1px"
                                borderColor={draft === view.id ? 'var(--color-accent)' : 'var(--color-border)'}
                            >
                                <HStack spacing={2}>
                                    <Radio value={view.id} colorScheme="blue" size="sm" />
                                    <Text fontSize="sm" isTruncated>{view.name}</Text>
                                    <Text fontSize="xs" color="var(--color-text-secondary)" flexShrink={0}>
                                        {view.type}
                                    </Text>
                                </HStack>
                            </Box>
                        ))}
                    </VStack>
                </RadioGroup>
                {startingViewId !== draft ? (
                    <Button
                        size="xs"
                        variant="ghost"
                        alignSelf="flex-start"
                        onClick={() => setDraft(startingViewId)}
                        color="var(--color-text-secondary)"
                    >{t('manage.revertChange')}</Button>
                ) : null}
            </VStack>
        </ManageDialogFrame>
    );
}
